module.exports = __webpack_public_path__ + "static/media/dropzone-picture.330252f3.svg";